import { dictionary } from "@dcc/lookup/dictionary/dictionary";
import { RiskIndexer, RiskLevel } from "@dcc/types/riskLevel";

const getRiskTitle = (): RiskIndexer<string> => ({
  [RiskLevel.Low]: dictionary.Tools_General_LowRisk,
  [RiskLevel.Increasing]: dictionary.Tools_General_IncreasingRisk,
  [RiskLevel.High]: dictionary.Tools_General_HighRisk
});

const getWeeklyRiskDescription = (
  isBingeDrinker: boolean
): RiskIndexer<string> => ({
  [RiskLevel.Low]: isBingeDrinker
    ? dictionary.DCC_Results_LowBingeDrinker
    : dictionary.DCC_Results_YoureDrinkingWithinTheLowRiskGuidelines,
  [RiskLevel.Increasing]:
    dictionary.DCC_Results_YourDrinkingIsPuttingYourHealthAtRisk,
  [RiskLevel.High]: dictionary.DCC_Results_YourDrinkingIsDangerous
});

const getMonthlyRiskDescription = (
  isBingeDrinker: boolean
): RiskIndexer<string> => ({
  [RiskLevel.Low]: isBingeDrinker
    ? dictionary.DCC_Results_YoureTakingDrinkFreeDays
    : dictionary.DCC_Results_YoureDrinkingWithinTheLowRiskGuidelines,
  [RiskLevel.Increasing]: dictionary.DCC_Results_YoureTakingDrinkFreeDays,
  [RiskLevel.High]: dictionary.DCC_Results_YoureTakingDrinkFreeDays
});

const getMonthlyRiskTipsTitle = (): RiskIndexer<string> => ({
  [RiskLevel.Low]: dictionary.DCC_Results_WantMoreIdeas,
  [RiskLevel.Increasing]: dictionary.DCC_Results_WantSupportToKeep,
  [RiskLevel.High]: dictionary.DCC_Results_WantSupportToKeep
});

const getMonthlyRiskTipsDescription = (): RiskIndexer<string> => ({
  [RiskLevel.Low]: dictionary.DCC_Results_ActivitiesToTryOnDrinkFreeDays,
  [RiskLevel.Increasing]: dictionary.DCC_Results_GetPracticalTips,
  [RiskLevel.High]: dictionary.DCC_Results_GetPracticalTips
});

const getWeeklyRiskLowTipTitle = () => dictionary.DCC_Results_WantMoreIdeas;
const getWeeklyRiskLowTipDescription = () =>
  dictionary.DCC_Results_ActivitiesToTryOnDrinkFreeDays;

export const getRiskText = (isBingeDrinker: boolean) => ({
  riskTitle: getRiskTitle(),
  weeklyRiskDescription: getWeeklyRiskDescription(isBingeDrinker),
  monthlyRiskDescription: getMonthlyRiskDescription(isBingeDrinker),
  monthlyRiskTipsTitle: getMonthlyRiskTipsTitle(),
  monthlyRiskTipsDescription: getMonthlyRiskTipsDescription(),
  weeklyRiskLowTipTitle: getWeeklyRiskLowTipTitle(),
  weeklyRiskLowTipDescription: getWeeklyRiskLowTipDescription()
});

export const riskToColour = {
  [RiskLevel.Low]: "green",
  [RiskLevel.Increasing]: "yellow",
  [RiskLevel.High]: "red"
};

export const LOW_DRINKER_BINGE_COLOUR = "orange";
